import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export function useAppSearchParams() {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const location = useLocation();

  const get = useCallback(
    (key: string) => {
      return searchParams.get(key);
    },
    [searchParams]
  );

  const set = useCallback(
    (obj: { [key: string]: string }) => {
      const urlSearchParams = new URLSearchParams(searchParams);
  
      for (const key in obj) {
        if (obj[key]) {
          urlSearchParams.set(key, obj[key]);
        } else {
          if (urlSearchParams.get(key)) urlSearchParams.delete(key);
        }
      }
  
      const newSearch = urlSearchParams.toString();
      const currentSearch = searchParams.toString();
  
      if (newSearch !== currentSearch) {
        navigate(`${location.pathname}?${newSearch}`, { replace: true });
      }
    },
    [location.pathname, navigate, searchParams]
  );
  

  const obj = useMemo(() => ({ get, set }), [get, set]);

  return obj;
}
